import type { FunctionComponent } from 'react';
import classNames from 'classnames';
import { CheckboxInput, Icon, ListItem, Tooltip } from '@george-labs.com/design-system';
import { ICON } from '@george-labs.com/george-assets/icons';

import type { FlatArrayFeature } from './types';

type Props = {
    flag: FlatArrayFeature;
};
export const FeatureListItem: FunctionComponent<Props> = ({ flag }) => {
    const { name, description, isEnabled, isOverridden, isHidden, valueFromApi } = flag;

    const className = classNames('pl-4', 'mr-0', {
        'd-none': isHidden,
        'g-fg-ui-red': isOverridden,
        'g-fg-ui-blue': !isOverridden && valueFromApi !== undefined,
    });

    return (
        <ListItem>
            <CheckboxInput
                className={className}
                checked={isEnabled}
                name={name}
                label={
                    <span>
                        {name}
                        {description && (
                            <Tooltip content={description}>
                                <Icon className="ml-1" assetIcon={ICON.INFO} />
                            </Tooltip>
                        )}
                        {valueFromApi !== undefined && (
                            <Tooltip
                                content={<>Flag service API: {valueFromApi ? 'on' : 'off'} </>}
                            >
                                <Icon className="ml-1" assetIcon={ICON.WORLD} />
                            </Tooltip>
                        )}
                    </span>
                }
            />
        </ListItem>
    );
};
